<template>
  <div class="kws-quiz-meter-bar">
    <div class="meter-bar-outer">
      <span class="meter-bar-inner" :style="`width: ${value}%`"></span>
    </div>
    <div class="meter-bar-text">{{ `${value} %` }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
  },
};
</script>

<style lang="scss">
.kws-quiz-meter-bar {
  position: relative;

  .meter-bar-outer {
    flex-basis: 100%;
    height: rem(24px);
    background-color: $color-kws-light-gray-75;
  }

  .meter-bar-inner {
    display: block;
    height: rem(24px);
    background-color: $color-kws-orange;
  }

  .meter-bar-text {
    text-align: right;
    font-weight: bold;
    font-size: rem(15px);
    line-height: rem(24px);
    white-space: nowrap;
    position: absolute;
    inset-inline-end: rem(4px);
    top: 0;
  }

  @media (min-width: rem(664px)) {
    display: flex;
    justify-content: space-between;

    .meter-bar-text {
      width: rem(60px);
      margin-inline-start: rem(20px);
      position: relative;
    }
  }

  @media (min-width: rem(1024px)) {
    width: 90%;
  }
}
</style>
